<!-- <hr > -->
<div class="row" [formGroup]="form">
  <div
    formArrayName="policies"
    *ngFor="let item of getControls(); index as i"
    class="row"
    style="display: flex; align-items: flex-end"
  >
    <!-- <div class="col-md-12 mt-4">
            <h6>Polizas {{i+1}}<button class="btn btn-danger" type="button" style="float: right" (click)="removeRow(i)">X </button></h6>
        </div> -->
  <div class="row">
    <!-- <div class="col-md-6">
      <h2>Póliza #{{i+1}}</h2>
    </div> -->
    <div class="col-md-6" [formGroupName]="i">
      <label class="form-labels mt-4">Compañia</label>
      <select formControlName="branch" class="form-select">
        <option selected></option>
        <option [value]="branch.id" *ngFor="let branch of branches">
          {{ branch.complete_name }}
        </option>
      </select>
    </div>
  </div>

    <div class="col-md-2" [formGroupName]="i">
      <label class="form-labels mt-4">Tipo de Contrato</label>
      <div class="input-group">
        <select
          formControlName="contractType"
          class="form-control"
          (change)="updateform()"
        >
          <option selected>-</option>
          <option value="personal">Personal</option>
          <option value="commercial">Comercial</option>
        </select>
      </div>
    </div>

    <div class="col-md-2" [formGroupName]="i">
      <label class="form-labels mt-4">Prefijo de la Poliza</label>
      <div class="input-group">
        <select
          formControlName="policyPrefix"
          class="form-control"
          (change)="updateform()"
        >
          <option selected>-</option>
          <option *ngFor="let prefix of prefixOptionsFiltered(item.get('contractType')?.value)" [ngValue]="prefix">
            {{ prefix.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-3" [formGroupName]="i">
      <label class="form-labels mt-4">Número de Poliza</label>
      <div class="input-group">
        <input
          type="text"
          formControlName="policyNumber"
          class="form-control"
          (change)="updateform()"
        />
      </div>
    </div>

    <div class="col-md-2" [formGroupName]="i">
      <label class="form-labels mt-4">Prima</label>
      <div class="input-group">
        <input
          type="number"
          formControlName="amount"
          (change)="updateTotal()"
          class="form-control"
        />
      </div>
    </div>

    <div class="col-md-2" [formGroupName]="i">
      <label class="form-labels mt-4">Pronto</label>
      <div class="input-group">
        <input
          type="number"
          formControlName="pronto"
          (change)="updatePronto()"
          class="form-control"
        />
      </div>
    </div>

    <div class="col-md-1">
      <button
        class="btn btn-danger"
        style="margin-top: 2.9rem"
        type="button"
        (click)="removeRow(i); updateform()"
      >
        X
      </button>
    </div>
    <!-- <div class="row">
      <div class="col-md-12" [formGroupName]="i">
        <label class="form-labels mt-4">Invoice (opcional)</label>
        <div class="input-group">
          <input aria-label="invoice" type="text" formControlName="invoice" class="form-control" />
        </div>
      </div>
    </div> -->
    <hr class="mt-4">
  </div>
  <div class="row mt-2">
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
    <div class="col-md-3"></div>
    <div class="col-md-2">{{ remainingBalance | currency }} disponible</div>
    <div class="col-md-2">{{ remainingPronto | currency }} disponible</div>
    <div class="col-md-1"></div>
  </div>
  <div class="row mt-4">
    <div class="col-md-3"></div>
    <div class="col-md-3"></div>
    <div class="col-md-2" style="color: red" *ngIf="remainingBalance < 0">
      {{ remainingBalance | currency }} | Se ha exedido de la prima total
    </div>
    <div class="col-md-2" style="color: red" *ngIf="remainingPronto < 0">
      {{ remainingPronto | currency }} | Se ha exedido del pronto total
    </div>
  </div>
</div>
<p>
  <button
    (click)="addItem()"
    style="max-width: 150px"
    class="btn btn-primary mt-4"
    [disabled]="maxAmountReached || maxAmountReachedPronto"
  >
    + Añadir Poliza
  </button>
</p>
